import { render, staticRenderFns } from "./GerenciaCadastroOcorrencias.vue?vue&type=template&id=9196385c"
import script from "./GerenciaCadastroOcorrencias.vue?vue&type=script&lang=js"
export * from "./GerenciaCadastroOcorrencias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports